import { AnimationOptions, motion, useAnimate } from "motion/react";
import {
  PropsWithChildren,
  RefObject,
  useImperativeHandle,
  useRef,
} from "react";
import { drawerContainer } from "./style.css";

export type DrawerRef = {
  open: () => Promise<void>;
  close: () => Promise<void>;
  isOpen: () => boolean;
};

type DrawerProps = {
  drawerRef?: RefObject<DrawerRef>;
};

const animationOptions: AnimationOptions = {
  duration: 0.5,
};

export const Drawer = ({
  drawerRef,
  children,
}: PropsWithChildren<DrawerProps>) => {
  const [scope, animate] = useAnimate<HTMLDivElement>();
  const isOpenRef = useRef(false);

  useImperativeHandle(
    drawerRef,
    () => ({
      open: async () => {
        document.body.style.overflow = "hidden";
        scope.current.style.height = "100%";
        await animate(
          scope.current,
          { y: 0 },
          { ...animationOptions, ease: "easeInOut" },
        );
        isOpenRef.current = true;
      },
      close: async () => {
        document.body.style.overflow = "auto";
        await animate(
          scope.current,
          { y: "-100%" },
          { ...animationOptions, delay: 0.1, ease: "easeInOut" },
        );
        scope.current.style.height = "0";
        isOpenRef.current = false;
      },
      isOpen: () => isOpenRef.current,
    }),
    [],
  );

  return (
    <motion.div
      ref={scope}
      className={drawerContainer}
      initial={{
        y: "-100%",
      }}
    >
      {children}
    </motion.div>
  );
};
